import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {Button} from '@travel-frontend/ui-components';

export const SortButton = styled(Button)(
  ({theme}) => css`
    width: 100%;
    min-width: 0;
    padding: 8px 0;

    &:hover {
      background-color: ${theme.colors.backgroundStateHover};
    }

    ${theme.respondUpTo(
      'md',
      css`
        flex: 1 0 40%;
      `
    )}
  `
);
